function ScrollMonitor(_dom, _css, _threshold, _ishome) {
  this.scrolling = -1;
  this.threshold = _threshold;
  this.target = $(_dom);
  this.style = _css;
  this.target = $(_dom);
  this.ishome = _ishome;

  this.footerOffset = 0;

  if (!this.ishome) {
    this.targetOffset = _threshold;
  }
  this.resize();
}

module.exports.ScrollMonitor = ScrollMonitor;

ScrollMonitor.prototype.resize = function() {
  if (this.ishome) {
    this.targetOffset = this.target.offset().top;
    this.targetH = this.target.outerHeight(true);
  } else {
    this.footerOffset = $(".footer").offset().top;
    this.targetH = this.target.outerHeight(true);
  }
  this.winH = $(window).height();
  this.target.removeClass("fixed");
  this.check();
};

ScrollMonitor.prototype.check = function() {
  var tempScroll = $(window).scrollTop();

  if (tempScroll != this.scrolling) {
    this.scrolling = tempScroll;

    if (this.ishome) {
      if (this.scrolling < this.targetOffset) {
        this.target.removeClass("fixed");
      } else {
        this.target.addClass("fixed");
      }
    } else {
      this.footerOffset = $(".footer").offset().top;
      // console.log(this.footerOffset,this.scrolling)
      if (this.scrolling < this.targetOffset) {
        this.target.removeClass("fixed");
      } else {
        this.target.addClass("fixed");
        if (this.scrolling > this.footerOffset - this.winH) {
          var bottom = this.scrolling - this.footerOffset + this.winH + 2;
          this.target.css("bottom", bottom);
        } else {
          this.target.css("bottom", 0);
        }
      }
    }
  }
};

function Scrolload(_ele, _class) {
  this.ele = _ele;
  this.className = _class;
  this.offset_arr = [];
  this.winH;
  this.able_to_show = 0;
  this.scroll_num = 0;
  this.scroll_num_temp = -1;
  this.list_num = this.ele.length;
  this.isFirst = false;
}

module.exports.Scrolload = Scrolload;

Scrolload.prototype.init = function() {
  this.getOffset();
  this.checkScroll();
};

Scrolload.prototype.reset = function() {
  this.offset_arr = [];
  this.able_to_show = 0;
  this.scroll_num = 0;
  this.getOffset();
};

Scrolload.prototype.getOffset = function() {
  var myself = this;
  this.winH = $(window).height();
  this.ele.each(function() {
    myself.offset_arr.push($(this).offset().top);
  });
};

Scrolload.prototype.checkScroll = function() {
  this.scroll_num = $(window).scrollTop();

  if (this.scroll_num_temp == this.scroll_num && !this.isFirst) {
    return false;
  }

  this.isFirst = false;

  this.scroll_num_temp = this.scroll_num;

  var threshold = this.winH / 1.15 + this.scroll_num;
  for (var i = this.able_to_show; i < this.list_num; i++) {
    if (this.offset_arr[i] < threshold) {
      this.ele.eq(this.able_to_show).addClass(this.className);
      // var myself = this;
      // var num = this.able_to_show;
      // aftereffect(this,this.able_to_show);
      this.able_to_show++;
    } else {
      break;
    }
  }

  // function aftereffect(_this,_num){
  // 	if(_this.ele.eq(_num).data('delay')){
  //     var delayTime = _this.ele.eq(_num).data('delay');
  //     var delayTime2 = delayTime + 600;
  // 	}else {
  //     var delayTime = 500;
  //     var delayTime2 = 1100;
  // 	}
  //   setTimeout(function(){
  //     _this.ele.eq(_num).addClass('show2');
  //   },delayTime);
  //   setTimeout(function(){
  //     _this.ele.eq(_num).addClass('active');
  //   },delayTime2);
  // }
};
